import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ReCaptcha2Component } from 'ngx-captcha';
import { environment } from './../../../environments/environment';

@Component({
    selector: 'app-recaptcha',
    templateUrl: './recaptcha.component.html',
    standalone: false
})
export class RecaptchaComponent {
    @ViewChild('recaptchaElement', { static: true }) private captchaElem: ReCaptcha2Component;
    @Input() public parentForm: UntypedFormGroup;
    @Input() public controlName: string;

    @Output() public loaded = new EventEmitter();
    @Output() public resetted = new EventEmitter();
    @Output() public succeeded = new EventEmitter();

    public useGlobalDomain = false;
    public size = 'normal';
    public language = 'nl';
    public theme = 'light';
    public type = 'image';

    public get siteKey(): string { return environment.recaptchaSiteKey; }

    public onLoaded(): void {
        this.loaded.emit();
    }

    public onResetted(): void {
        this.resetted.emit();
    }

    public onExpired(): void {
        this.resetted.emit();
    }

    public onSucceeded(): void {
        this.succeeded.emit();
    }

    public forceReset(): void {
        this.captchaElem.resetCaptcha();
    }
}
